import request from '@/util/request';
// import qs from 'qs';

//获取出库列表
export const getOutboundList = (params, options) =>
    request.get('/api/v4ward/warehouse/outbound/page', Object.assign({}, options, { params }));
//新增出库
export const outboundSave = (params, options) =>
    request.post('/api/v4ward/warehouse/outbound/submit', params, options);
//获取出库单详情
export const outboundDetail = (params, options) =>
    request.get('/api/v4ward/warehouse/outbound/detail', Object.assign({}, options, { params }));
    
export const treeByProjectDeptId = (params, options) =>
    request.get('/api/v4ward/dept/treeByProjectDeptId', Object.assign({}, options, { params }));

export const getUserListByDept = (params, options) =>
    request.get('/api/v4ward/user/user-list-by-dept', Object.assign({}, options, { params }));
//出库单详情-货品列表
export const outboundConsumableList = (params, options) =>
    request.get('/api/v4ward/warehouse/stock/consumableList', Object.assign({}, options, { params }));
 //出库单详情-货品列表
export const outboundSummary = (params, options) =>
request.get('/api/v4ward/warehouse/outbound/summary', Object.assign({}, options, { params }));
   
    